export default "__VITE_ASSET__3jJKNoRd__"